/**
 * Universal card component for both templates and existing apps
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { BLUE, GRAY, SANS_SERIF } from '../styles'
import { SHOPIFY } from 'constants/integrationType'

// import instagramImage from 'assets/instagram.png'
import shopifyImage from 'assets/shopify.jpg'

const Container = styled.div`
  margin: 0 10px 20px 10px;
  width: 180px;
  height: 380px;
  border: 4px solid ${props => props.selected ? BLUE : '#fff'};
  box-shadow: 0 2px 6px 1px rgba(144, 144, 144, 0.5);

  position: relative;
  cursor: pointer;
  transition: all 0.15s ease-out;
`
const Image = styled.div`
  position: absolute;
  top: 5%;
  left: 8%;
  right: 8%;
  bottom: 35%;
  background: url('${props => props.image}') center / cover no-repeat;
`
const Content = styled.div`
  position: absolute;
  top: 68%;
  left: 0;
  right: 0;
  text-align: center;
`
const Title = styled.div`
  margin-bottom: 3px;

  ${SANS_SERIF}
  text-transform: uppercase;
  font-size: 70%;
  font-weight: 900;
`
const Category = styled.div`
  margin-bottom: 8px;

  font-size: 50%;
  color: ${GRAY};
`
const Status = styled.div`
  margin-bottom: 15px;
  padding-top: 8px;

  font-size: 50%;
  color: ${GRAY};
`
const Description = styled.div`
  padding: 0 3%;
  font-size: 50%;
`
const Modified = styled.div`
  padding: 0 3%;

  display: flex;
  justify-content: space-between;

  font-size: 41%;
  color: ${GRAY};
`
const Integrations = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 90%;

  display: flex;
  align-items: flex-start;
  justify-content: space-around;
`
// const Instagram = styled.div`
//   width: 70px;
//   padding: 18px 0 0 0;
//
//   background: url('${props => props.image}') no-repeat;
//   background-size: 100% auto;
//   background-position: 0 3px;
//   text-align: center;
//   font-size: 50%;
//   color: ${GRAY};
// `
const Shopify = styled.div`
  width: 55px;
  padding: 18px 0 0 0;

  background: url('${props => props.image}') no-repeat;
  background-size: 100% auto;
  background-position: 0 0;
  text-align: center;
  font-size: 50%;
  color: ${GRAY};
`

class DashboardCard extends Component {

  selectCard = () => this.props.selectCard(this.props.id)

  render () {
    const { type, image, title, category, published, description, lastModified, integrations, selected } = this.props
    const titleShort = title.length > 14 ? title.substring(0, 14) + '...' : title
    return (
      <Container selected={selected} onClick={this.selectCard}>
        <Image image={image} />
        {(type === 'template')
          ? (
            <Content>
              <Title>{titleShort}</Title>
              <Category>{category}</Category>
              <Description>{description}</Description>
            </Content>
          )
          : (
            <Content>
              <Title>{titleShort}</Title>
              <Status>{published ? 'PUBLISHED' : 'NOT PUBLISHED'}</Status>
              <Modified>
                <div>Last modified:</div>
                <div>{lastModified}</div>
              </Modified>
            </Content>
          )
        }
        <Integrations>
          {/* <Instagram image={instagramImage}>
            enabled
          </Instagram> */}
          {(integrations.indexOf(SHOPIFY) > -1) &&
            <Shopify image={shopifyImage}>
              enabled
            </Shopify>
          }
        </Integrations>
      </Container>
    )
  }
}

DashboardCard.propTypes = {
  id: PropTypes.string,
  type: PropTypes.oneOf(['template', 'app']),
  image: PropTypes.string,
  title: PropTypes.string,
  category: PropTypes.string,
  published: PropTypes.bool,
  description: PropTypes.string,
  lastModified: PropTypes.string,
  integrations: PropTypes.array,
  selected: PropTypes.bool,
  selectCard: PropTypes.func,
}

export default DashboardCard



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardCard.js